import { render, staticRenderFns } from "./ExportConfigWidget.vue?vue&type=template&id=908a7c80&"
import script from "./ExportConfigWidget.vue?vue&type=script&lang=js&"
export * from "./ExportConfigWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports